import EventBus from "./event-bus";
import {millisToDate} from "./utils";

let header = {
  headers: {
    appId:'boriumweb',
    appKey: 'iasofjsovsdlvsdvlsnflsfhuawefawefnwaeflnjnv-=sf',
    "Content-Type": "application/json",
  }
}
let boriumUrl = 'https://posapi.boriumstudio.com/';
// let boriumDbUrl = 'http://10.0.100.3:9090/api/public/'
const axios = require('axios');

export function getMerchants() {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true, "Getting Restaurant list");
    axios.get(boriumUrl + 'public_merchants.php', header)
      .then(function(response){
        EventBus.$emit("showLoading",false);
          // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit("showLoading",false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getProduct(pid) {
  return new Promise(function(resolve, reject) {
    let url = boriumUrl + 'publicProduct.php?pid='+ pid;
    // console.log("URL to get merchant " + url);

    EventBus.$emit('showLoading', true, "Loading Product Information")
    axios.get(url, header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getMerchant(merchantId, type = null) {
  return new Promise(function(resolve, reject) {
    let url = boriumUrl + 'public_merchant.php?merchantId='+ merchantId;
    // console.log("URL to get merchant " + url);
    if(type != null) {
      url += '&type=' + type;
    }
    EventBus.$emit('showLoading', true, "Getting Restaurant")
    axios.get(url, header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
         // console.log("Error at getting list " + err);
         // if(err.response != undefined) {
         //   console.log(err.response);
         // }
        reject(err);
      })
  })
}
export function getMerchantUrl(url) {
  return new Promise(function(resolve, reject) {
    url = boriumUrl + 'public_merchant.php?url='+ url;
    // console.log("URL to get merchant " + url);

    EventBus.$emit('showLoading', true, "Getting Restaurant")
    axios.get(url, header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}

export function getMerchantPermalink(permalink) {
  return new Promise(function(resolve, reject) {
    let url = boriumUrl + 'public_merchant.php?permalink='+ permalink;
    // console.log("URL to get merchant " + url);

    EventBus.$emit('showLoading', true, "Getting Restaurant")
    axios.get(url, header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}

export function getMerchantMenus(merchantId, type='web') {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Getting Menus")
    let pre = new Date().getTime();
    axios.get(boriumUrl + 'public_menus.php?merchantId='+ merchantId+'&type='+type, header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        let n = new Date().getTime();
        let diff = n-pre;
        // console.log("took " + diff + "ms");
        // console.log("merchants menu list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getTableMerchant(tableId) {
  return new Promise(function(resolve, reject) {
    axios.get(boriumUrl + 'public_finder.php?tableId='+ tableId, header)
      .then(function(response){
        // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}

export function submitOrder(item) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.SHOWMEMENU_API + 'order/place', JSON.stringify(item), header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}

export function sendTableRequest(subscriptionId, cmd, request, tableId) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Sending request...");
    axios.get(process.env.SHOWMEMENU_API + 'merchant/table/request?subscriptionId=' + subscriptionId + "&cmd=" + cmd + "&request=" + request + "&tableId=" + tableId, header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function submitLog(subscriptionId, site, type) {

  let item = {
    id:0,
    subscriptionId: subscriptionId,
    site:site,
    type:type,
    date:millisToDate(),
    hour:new Date().getHours(),

  }


  return new Promise(function(resolve, reject) {
    axios.post(process.env.SHOWMEMENU_API + 'weblog', JSON.stringify(item), header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function submitTableOrder(item) {
  return new Promise(function(resolve, reject) {
    let params = "tableId=" + item.tableId;
    params += "&orderId=" +item.id;
    if(item.memo != null && item.memo.length > 0) {
      params += "&memo=" + item.memo;
    }
    if(item.phoneNumber != null && item.phoneNumber.length > 0) {
      params += '&phoneNumber='+item.phoneNumber;
    }
    if(item.email != null && item.email.length > 0) {
      params += '&email=' + item.email;
    }
    if(item.headCount != undefined && item.headCount != null) {
      params += '&headCount=' + item.headCount;
    }
    axios.get(process.env.SHOWMEMENU_API + 'order/table/submit?' + params, header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function deleteTableItem(id) {
  return new Promise(function(resolve, reject) {
    axios.delete(process.env.SHOWMEMENU_API + 'order/table/item?id='+id, header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function updateTableItem(item) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.SHOWMEMENU_API + 'order/table/item', JSON.stringify(item), header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function addItemsToTable(item) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "adding item");
    axios.post(process.env.SHOWMEMENU_API + 'order/table/add', JSON.stringify(item), header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        EventBus.$emit('showLoading', false);
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function createNewPreOrder(order) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'preorder';
    EventBus.$emit('showLoading', true, "Creating Session")
    axios.put(url , JSON.stringify(order), header)
      .then(function(response) {
        // console.log("getOrderToken response");
        EventBus.$emit('showLoading', false);
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getPreOrder(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Getting Session");
    let url = process.env.SHOWMEMENU_API + 'preorder?id='+id;
    axios.get(url , header)
      .then(function(response) {
        EventBus.$emit('showLoading', false);
        // console.log("getOrderToken response");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function deletePreOrderItem(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Getting Session");
    let url = process.env.SHOWMEMENU_API + 'preorder/item?id='+id;
    axios.delete(url , header)
      .then(function(response) {
        EventBus.$emit('showLoading', false);
        // console.log("getOrderToken response");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function updatePreOrder(order) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.SHOWMEMENU_API + 'preorder', JSON.stringify(order), header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function addPreOrderItem(item) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.SHOWMEMENU_API + 'preorder/item', JSON.stringify(item), header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getTablePendingOrder(tableId) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'order/table/pending?tableId='+tableId;
    axios.get(url , header)
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function sendReceipt(id, email) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Sending Receipt");
    let url = process.env.SHOWMEMENU_API + 'order/receipt?id='+id + "&email=" + email;
    axios.get(url , header)
      .then(function(response) {
        EventBus.$emit('showLoading', false);
        // console.log("getOrderToken response");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getOrderToken(item, phoneNumber = null, subscriptionId) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'order/token?orderId='+item.id;
    if(phoneNumber != null) {
      url += '&phoneNumber='+phoneNumber;
    }
    url += '&subscriptionId=' + subscriptionId;
    axios.get(url , header)
      .then(function(response) {
        // console.log("getOrderToken response");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getOrderPayments(id) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.SHOWMEMENU_API + 'order/payment?id='+id , header)
      .then(function(response) {
        // console.log("getOrderToken response");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}

export function getMyOrder(phoneNumber, merchantId) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.SHOWMEMENU_API + 'order/my?phoneNumber=' + phoneNumber + "&subscriptionId=" + merchantId, header)
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}
export function updateMyOrder(obj) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.SHOWMEMENU_API + 'order/update/status', JSON.stringify(obj), header)
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}


export function getDistance(from, to) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.SHOWMEMENU_API + 'delivery/distance?from='+from + '&to=' + to, header)
      .then(function(response) {
        let data = response.data;
        EventBus.$emit("showLoading", false);
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit("showLoading", false);
        reject(err);
      })
  })
}

export function getUserPoint(phoneNumber, merchantId) {
  return new Promise(function(resolve, reject) {
    // EventBus.$emit("showLoading", true);
    axios.get(process.env.SHOWMEMENU_API + 'points/phoneNumber?phoneNumber='+phoneNumber + '&subscriptionId=' + merchantId, header)
      .then(function(response) {
        let data = response.data;
        // EventBus.$emit("showLoading", false);
        resolve(data);
      })
      .catch(function(err) {
        // EventBus.$emit("showLoading", false);
        reject(err);
      })
  })
}
export function updatePaymentItem(order) {
  return new Promise(function(resolve, reject) {
    // EventBus.$emit("showLoading", true);
    axios.post(process.env.SHOWMEMENU_API + 'order/card/paid', JSON.stringify(order), header)
      .then(function(response) {
        let data = response.data;
        // EventBus.$emit("showLoading", false);
        resolve(data);
      })
      .catch(function(err) {
        // EventBus.$emit("showLoading", false);
        reject(err);
      })
  })
}

export function registerVisitor(visitor) {
  return new Promise(function(resolve, reject) {
    // EventBus.$emit("showLoading", true);
    axios.post(process.env.SHOWMEMENU_API + 'visitor', JSON.stringify(visitor), header)
      .then(function(response) {
        let data = response.data;
        // EventBus.$emit("showLoading", false);
        resolve(data);
      })
      .catch(function(err) {
        // EventBus.$emit("showLoading", false);
        reject(err);
      })
  })
}
export function setVisitorSeat(visitor) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.post(process.env.SHOWMEMENU_API + 'visitor/seat', JSON.stringify(visitor), header)
      .then(function(response) {
        let data = response.data;
        EventBus.$emit("showLoading", false);
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit("showLoading", false);
        reject(err);
      })
  })
}
export function getOrder(id) {
  return new Promise(function(resolve, reject) {
    // EventBus.$emit("showLoading", true);
    axios.get(process.env.SHOWMEMENU_API + 'order?orderId=' + id, header)
      .then(function(response) {
        let data = response.data;
        // EventBus.$emit("showLoading", false);
        resolve(data);
      })
      .catch(function(err) {
        // EventBus.$emit("showLoading", false);
        reject(err);
      })
  })
}
export function getMyPendingOrder(phoneNumber) {
  return new Promise(function(resolve, reject) {
    // EventBus.$emit("showLoading", true);
    axios.get(process.env.SHOWMEMENU_API + 'mypending/orders?phoneNumber=' + phoneNumber, header)
      .then(function(response) {
        let data = response.data;
        // EventBus.$emit("showLoading", false);
        resolve(data);
      })
      .catch(function(err) {
        // EventBus.$emit("showLoading", false);
        reject(err);
      })
  })
}


export function getMyOrderDeliveryJob(id) {
  return new Promise(function(resolve, reject) {
    // EventBus.$emit("showLoading", true);
    axios.get(process.env.SHOWMEMENU_API + 'order/job?id=' + id, header)
      .then(function(response) {
        let data = response.data;
        // EventBus.$emit("showLoading", false);
        resolve(data);
      })
      .catch(function(err) {
        // EventBus.$emit("showLoading", false);
        reject(err);
      })
  })
}

export function getBookingTimeTable(merchantId) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.SHOWMEMENU_API + 'restaurant/' + merchantId + '/booking/table', header)
      .then(function(response){
        // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getUnavailableBookingTime(merchantId, date) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.SHOWMEMENU_API + 'merchant/' + merchantId + '/booking/hours/unavailable?dateFrom=' + date + '&dateTo=' + date, header)
      .then(function(response){
        // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getAvailableSlots(merchantId, numberOfGuest, date, time, query) {
  let url = process.env.SHOWMEMENU_API + 'booking/' + merchantId + "/" + numberOfGuest + "/" + date + "/" + time + "/availability";
  if(query !== null && query.length > 0) {
    url += "?" + query;
  }
  return new Promise(function(resolve, reject) {
    axios.get(url, header)
      .then(function(response){
        // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getBookingTypes(merchantId) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.SHOWMEMENU_API + 'merchant/' + merchantId + '/hours/type/booking_type', header)
      .then(function(response){
        // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getHolidayList(merchantId, date) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.SHOWMEMENU_API + 'merchant/' + merchantId + '/holidays?dateFrom=' + date, header)
      .then(function(response){
        // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function submitBooking(item) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.SHOWMEMENU_API + 'booking', JSON.stringify(item), header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function submitReservedBooking(item) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.SHOWMEMENU_API + 'booking/submit', JSON.stringify(item), header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function reserveBooking(item) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Reserving a table");
    axios.post(process.env.SHOWMEMENU_API + 'booking/reserve', JSON.stringify(item), header)
      .then(function(response) {
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        reject(err);
      })
  })
}

export function cancelReservedBooking(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Cancelling reserved table");
    axios.delete(process.env.SHOWMEMENU_API + 'booking/reserve/' + id + '/cancel', header)
      .then(function(response) {
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        reject(err);
      })
  })
}
export function verifyBookingItemEmailAddress(id, code) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Verification in progress");
    axios.get(process.env.SHOWMEMENU_API + 'booking/verify/email/' + id + '?code=' + code, header)
      .then(function(response) {
        // console.log(response);
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function bookingCardDepositPreAuthorise(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Verification in progress");
    axios.get(process.env.SHOWMEMENU_API + 'booking/deposit/' + id, header)
      .then(function(response) {
        // console.log(response);
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function cancelBookingItem(id, key) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Cancellation in progress");
    axios.get(process.env.SHOWMEMENU_API + 'booking/customer/cancel/' + id + '?key=' + key, header)
      .then(function(response) {
        // console.log(response);
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getBookingItem(id, key) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Getting Reservation Data")
    axios.get(process.env.SHOWMEMENU_API + 'booking/' + id + '?key=' + key, header)
      .then(function(response) {
        // console.log(response);
        EventBus.$emit('showLoading', false);
          let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getBookingMerchantItem(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Getting Reservation Data")
    axios.get(process.env.SHOWMEMENU_API + 'booking/merchant/' + id, header)
      .then(function(response) {
        // console.log(response);
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getPSStatusCodeMessage(code) {
  if(code == 4) {
    return 'Referred';
  } else if(code == 5) {
    return 'Declined';
  } else if(code == 20) {
    return 'Duplicate Transaction';
  } else if(code == 30) {
    return 'Failed';
  } else if(code == 400) {
    return 'Invalid Request';
  } else if(code == 401) {
    return 'Session expired. Please try again';
  } else if(code == 404) {
    return 'No session made. Please try again';
  } else if(code == 500) {
    return 'Server Error';
  }
  return 'Unknown error';
}
export function getJonStatus() {
  let list = [
    {
      status:0,
      title:'Looking for rider',
    },
    {
      status:1,
      title:'Assigned',
    },
    {
      status:2,
      title:'Arrived at Restaurant',
    },
    {
      status:3,
      title:'Food Picked up',
    },
    {
      status:4,
      title:'Arrived at destination',
    },
    {
      status:5,
      title:'Food Delivered',
    }
  ];

  return list;
}
export function getMerchantSettings(subscriptionId, type) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Getting Reservation Data")
    axios.get(process.env.SHOWMEMENU_API + 'merchant/' + subscriptionId + '/settings?type='+type, header)
      .then(function(response) {
        // console.log(response);
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function submitInquiryForm(form) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Submitting your inquiry")
    axios.post(process.env.SHOWMEMENU_API + 'merchant/inquiry/submit', JSON.stringify(form), header)
      .then(function(response) {
        // console.log(response);
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}

export function getLoyaltyCardEmail(email, mId, type) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/loyalty/'  + type + '?email='+ email + '&merchant=' + mId;
    // console.log("URL to get merchant " + url);

    EventBus.$emit('showLoading', true, "Getting your Loyalty Card");
    axios.get(url, header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}

export function getJoinLoyaltyCard(form) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/loyalty/create';
    // console.log("URL to get merchant " + url);

    EventBus.$emit('showLoading', true, "Creating your Loyalty Card");
    axios.post(url, JSON.stringify(form), header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getLoyaltyMerchant(id) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/loyalty/merchant/' + id;
    // console.log("URL to get merchant " + url);

    EventBus.$emit('showLoading', true, "Getting your Loyalty Card");
    axios.get(url, header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/borium.js